import { useDispatch, useSelector } from "react-redux";
import { CaptureStepTypes } from "@enums/capture-step-types";
import {
    getUseAcuantSDKDPIValidation,
    getUseAcuantSDKGlareValidation,
    getUseAcuantSDKSharpnessValidation
} from "@redux/selectors/verification-configuration-selectors";
import { getInitialIdCardFrontCaptureStepValidationsMap } from "@utils/capture-step-validation-util";
import { setCaptureStepValidationResults } from "@redux/actions/validation-results-actions";
import { CaptureStepPage } from "../capture-step-page/capture-step-page";
import { useAuditLogger } from "@hooks/use-audit-logger";
import { AuditLogTypes } from "@constants/audit-log-types";
import { useEffect } from "react";

export const IdCardFrontPage = () => {
    const dispatch = useDispatch();

    const { writeAuditLog } = useAuditLogger();

    useEffect(() => {
        writeAuditLog(AuditLogTypes.DCUI_ID_CARD_FRONT_STEP_START);    
    }, []);

    const useAcuantSDKGlareValidation = useSelector(getUseAcuantSDKGlareValidation);
    const useAcuantSDKSharpnessValidation = useSelector(getUseAcuantSDKSharpnessValidation);
    const useAcuantSDKDPIValdidation = useSelector(getUseAcuantSDKDPIValidation);

    const resetCaptureStepValidationResults = () => {
        const initialValidationResults = getInitialIdCardFrontCaptureStepValidationsMap(useAcuantSDKDPIValdidation, useAcuantSDKGlareValidation, useAcuantSDKSharpnessValidation);
        dispatch(setCaptureStepValidationResults(CaptureStepTypes.ID_CARD_FRONT, initialValidationResults));
    };

    return (
        <CaptureStepPage
            captureStepType={CaptureStepTypes.ID_CARD_FRONT}
            showQualityAdviceMessage={true}
            resetCaptureStepValidationResults={resetCaptureStepValidationResults}
        />
    );
};